import React from 'react'
import { Card, FloatButton } from 'antd'
import RubricPreview from './preview/RubricPreview'
import PrintableContent from '../../../../components/common/printable-content/PrintableContent'
import { DownloadOutlined } from '@ant-design/icons'
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle'
import { useSelector } from 'react-redux'
import assignmentSelectors from '../../../../store/selectors/assignment.selectors'

const RubricSection = () => {
    const assignmentName = useSelector(assignmentSelectors.name)
    useDocumentTitle(assignmentName)

    const printPdf = () => window.print()

    return (
        <Card title='Document preview'>
            <PrintableContent>
                <RubricPreview />
            </PrintableContent>
            <FloatButton onClick={printPdf} type='primary' icon={<DownloadOutlined />} title='Download' />
        </Card>
    )
}

export default RubricSection
